import React from 'react';
import { Box, Paper, Typography } from '@mui/material';

/** `data-help-section` is passed straight through to the card so a screen can tag it for help mode. */
export function DashSection({ title, subtitle, children, ...rest }: { title: string; subtitle?: string; children: React.ReactNode; 'data-help-section'?: string }) {
    return (
        <Paper variant="outlined" sx={{ p: 2, minWidth: 0 }} {...rest}>
            <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>{title}</Typography>
            {subtitle && <Typography variant="caption" color="text.secondary" sx={{ display: 'block', mb: 1 }}>{subtitle}</Typography>}
            <Box sx={{ mt: subtitle ? 0 : 1 }}>{children}</Box>
        </Paper>
    );
}

export function DashEmpty({ text }: { text: string }) {
    return <Typography variant="body2" color="text.secondary" sx={{ py: 2 }}>{text}</Typography>;
}
